import type { TenantMemberEmbeds } from '@kudos/http-client'

const RICH_PREVIEW_EMBEDS: TenantMemberEmbeds[] = [
  'avatar',
  'publicStaffProfile',
  'events',
  'email',
]
const LEGACY_PREVIEW_EMBEDS: TenantMemberEmbeds[] = ['avatar', 'publicStaffProfile']

/**
 * The rich profile card renders the member's email and celebration events; the legacy
 * popper reads neither, so it only pays for the avatar and public staff profile.
 * Returns the shared constants so the array reference stays stable across renders.
 */
export const getPreviewEmbeds = (richPreview: boolean): TenantMemberEmbeds[] =>
  richPreview ? RICH_PREVIEW_EMBEDS : LEGACY_PREVIEW_EMBEDS
